import { IApplicationContext } from 'shared/mf-my-home/types/applicationContext';
import { TApplicationState, TReduxStore } from 'shared/mf-my-home/types/redux';
import { createReduxStore } from 'shared/mf-my-home/utils/redux';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  return createReduxStore(context, initialState, true);
}
